import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ListingCollabImage } from "../collaborators/ListingCollabImage";
import { BadgeVerification } from "../../../global/badgeVerification/BadgeVerification";
import { ListingCoachAvatar } from "./ListingCoachAvatar";

export const ListingCoachAndCollabImgs = () => {
  const listingDataRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData
  );
  const quantityOfCollaborators = listingDataRedux.collaborators.length;

  if (quantityOfCollaborators === 0) {
    return (
      <div className={`flex items-start relative cursor-pointer `}>
        <div
          className="relative"
          onClick={() => {
            document
              .querySelector("#coach-section")
              .scrollIntoView({ behavior: "smooth" });
          }}
        >
          <ListingCoachAvatar />
          {listingDataRedux.user.verificationBadge && (
            <BadgeVerification
              isFromSpecialist={true}
              type={listingDataRedux.user.verificationBadge}
              className="absolute bottom-0 right-0 z-20"
            />
          )}
        </div>
      </div>
    );
  }

  if (quantityOfCollaborators === 1) {
    return (
      <div
        style={{ width: 83, height: 75 }}
        className={`flex items-start relative cursor-pointer `}
      >
        <div
          className="relative"
          onClick={() => {
            document
              .querySelector("#coach-section")
              .scrollIntoView({ behavior: "smooth" });
          }}
        >
          <ListingCoachAvatar />
        </div>

        <ListingCollabImage
          data={listingDataRedux.collaborators[0]}
          className="bottom-0 right-0 absolute"
        />
      </div>
    );
  }

  if (quantityOfCollaborators === 2) {
    return (
      <div
        style={{ width: 87, height: 78 }}
        className={`flex items-start relative cursor-pointer `}
      >
        <div
          onClick={() => {
            document
              .querySelector("#coach-section")
              .scrollIntoView({ behavior: "smooth" });
          }}
          className="absolute bottom-0 right-1/2 transform translate-x-1/2 z-10"
        >
          <ListingCoachAvatar />
        </div>

        <ListingCollabImage
          data={listingDataRedux.collaborators[0]}
          className="top-0 right-0 absolute"
        />

        <ListingCollabImage
          data={listingDataRedux.collaborators[1]}
          className="top-0 left-0 absolute"
        />
      </div>
    );
  }
};
